import withAPIAction from 'utils/withAPIAction'
import { getDataListAction } from './actions'
import { GetDataListReq } from './types'
import { verifyReq } from 'utils/verify'

export const getDataList = (token: string, data: GetDataListReq) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetDataListReq>({
    method: 'POST',
    path: 'GetSiriconFiles',
    data,
    token: `Bearer ${token}`,
  })(getDataListAction)
}
